import Vue from 'vue'
import Vuex from 'vuex'
import API from './modules/CallApi.js'
import Lookup from './modules/Lookup.js'
import AD from './modules/ApplicantDetail.js'
import ED from './modules/EmploymentDetails.js'
import FATCA from './modules/FATCA.js'
import Transactions from './modules/Transactions.js'
import AOD from './modules/AccountOpeningDetails.js'
import Product from './modules/product.js'
import CD from './modules/clientDetail.js'
import cart from './modules/cart'
import Login from './modules/LoginDetails'

import Styles from './modules/Styles.js'

import axios from 'axios'
import createPersistedState from 'vuex-persistedstate';


Vue.use(Vuex)
Vue.prototype.$axios = axios

export default new Vuex.Store({
    modules: {
        AD,
        AOD,
        API,
        Lookup,
        ED,
        FATCA,
        Transactions,
        Product,
        cart,
        CD,
        Login,
        Styles
    },
    plugins: [createPersistedState()],
})
